import React from 'react'

import { Label } from '@pb/components'
import cn from 'classnames'

import ExpandedOrder from '../ExpandedOrder'
import OrderHeader from '../OrderHeader'
import PurchaseCore from '../PurchaseCore'
import PurchaseDetails from '../PurchaseDetails'
import styles from './Order.scss'

const Order: React.FC<any> = ({
  order,
  expandedOrderId,
  loadingOrderId,
  toggleExpandedOrder,
  runKlarnaOp,
  iterator,
  isVisible,
  className,
  isTargetApp,
}) => {
  const { orderId, totalAmount, createdAt, dueDate, status, statusDescription } = order

  const renderHeader = (): any => (
    <OrderHeader
      orderCreatedAt={createdAt}
      orderDueDate={dueDate}
      orderAmount={totalAmount}
      orderStatus={status}
      orderStatusDescription={
        statusDescription || <Label copyKey="profile.order.status.inProgress" />
      }
    />
  )

  return (
    <PurchaseCore
      className={cn(styles.container, className, loadingOrderId === orderId && styles.blurred)}
      headerClassName={`${styles.header}`}
      orderId={orderId}
      expandedOrderId={expandedOrderId}
      toggleExpandedOrder={toggleExpandedOrder}
      iterator={iterator}
      isVisible={isVisible}
      shouldShowSpinner={loadingOrderId === orderId}
      shouldWrapContent
      header={renderHeader()}
    >
      <PurchaseDetails isExpanded={expandedOrderId === order.orderId}>
        <ExpandedOrder order={order} runKlarnaOp={runKlarnaOp} isTargetApp={isTargetApp} />
      </PurchaseDetails>
    </PurchaseCore>
  )
}

export default Order
